import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import PageTitle from "../page-title";
import ReturnLink from "../return-link";

import "./page-header.scss";

const PageHeader = ({
  returnUrl,
  isExternalLink,
  onReturnLinkClick,
  returnLinkText,
  pageTitleId,
  pageTitleText,
  children
}) => (
  <div className="page-header">
    {returnUrl && (
      <ReturnLink
        url={returnUrl}
        onClick={onReturnLinkClick}
        isExternalLink={isExternalLink}
      >
        {returnLinkText}
      </ReturnLink>
    )}
    <PageTitle
      className={cn(
        "page-header__title",
        `${returnUrl && "page-header__title--reduced"}`
      )}
      id={pageTitleId}
    >
      {pageTitleText}
    </PageTitle>
    {children}
  </div>
);

PageHeader.defaultProps = {
  returnUrl: "",
  isExternalLink: false,
  onReturnLinkClick: () => null,
  returnLinkText: "",
  pageTitleId: ""
};

PageHeader.propTypes = {
  returnUrl: PropTypes.string,
  isExternalLink: PropTypes.bool,
  onReturnLinkClick: PropTypes.func,
  returnLinkText: PropTypes.string,
  pageTitleId: PropTypes.string,
  pageTitleText: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default PageHeader;
